module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "rows"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content reporting-row"
  }, [_c('div', {
    staticClass: "container form-group col-lg-5"
  }, [_c('label', [_vm._v("Villes")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedVille),
      expression: "selectedVille"
    }],
    staticClass: "form-control demande-filters",
    attrs: {
      "id": "ville"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedVille = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changedSelect()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Sélectionner une ville")]), _vm._v(" "), _vm._l((_vm.villes.availableVilles), function(ville) {
    return _c('option', {
      key: ville.id,
      attrs: {
        "item": _vm.selectedVille
      },
      domProps: {
        "value": ville
      }
    }, [_vm._v("\n            " + _vm._s(ville.nom) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 pull-right"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block save-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveModifications()
      }
    }
  }, [_vm._v("\n          Sauvegarder\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.selectedVille && _vm.selectedVille.parametragebos), function(mod) {
    return _c('div', {
      key: mod.nom,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Module")]), _vm._v(" "), _c('span', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(mod.libelle))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('span', {
      staticClass: "title-item"
    }, [_vm._v("Actif ?")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (mod.actif),
        expression: "mod.actif"
      }],
      staticClass: "big-checkbox text-item",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(mod.actif) ? _vm._i(mod.actif, null) > -1 : (mod.actif)
      },
      on: {
        "change": function($event) {
          var $$a = mod.actif,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(mod, "actif", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(mod, "actif", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(mod, "actif", $$c)
          }
        }
      }
    })])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d9a7963!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/administration/AdministrationBackoffice.vue
// module id = 2088
// module chunks = 2